import React, { useState } from "react";
import { FaSortAmountDown, FaFileAlt, FaSearch, FaSortNumericDown, FaWindowClose } from "react-icons/fa";


const FilterModel = ({ isOpen, onClose, onApply }) => {
  const [localFilters, setLocalFilters] = useState({
    per_page: 10,
    page: 1,
    order_by: "created_at",
    search: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLocalFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const applyFilters = () => {
    const cleanedFilters = Object.fromEntries(
      Object.entries(localFilters).filter(([_, v]) => v !== "")
    );
    onApply(cleanedFilters); // Kirim hanya filter yang terisi
  };

  return (
    <div className={`fixed inset-0 bg-black bg-opacity-50 z-50 ${isOpen ? "flex" : "hidden"} justify-center items-center`}>
  <div className="bg-white p-6 rounded-2xl shadow-2xl w-96 space-y-4">
    <h2 className="text-2xl font-bold text-gray-800 mb-2 flex items-center gap-2">
      <FaFileAlt className="text-blue-500" />
      Filter Obat
    </h2>

    {/* Per Page */}
    <div>
      <label className="block mb-1 text-sm font-semibold text-gray-700 flex items-center gap-2">
        <FaSortNumericDown className="text-gray-500" />
        Per Page:
      </label>
      <input
        type="number"
        name="per_page"
        value={localFilters.per_page}
        onChange={handleChange}
        className="w-full px-4 py-2 border rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow-300"
      />
    </div>

    {/* Page */}
    <div>
      <label className="block mb-1 text-sm font-semibold text-gray-700 flex items-center gap-2">
        <FaSortNumericDown className="text-gray-500" />
        Page:
      </label>
      <input
        type="number"
        name="page"
        value={localFilters.page}
        onChange={handleChange}
        className="w-full px-4 py-2 border rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow-300"
      />
    </div>

    {/* Order By */}
    <div>
      <label className="block mb-1 text-sm font-semibold text-gray-700 flex items-center gap-2">
        <FaSortAmountDown className="text-gray-500" />
        Order By:
      </label>
      <select
        name="order_by"
        value={localFilters.order_by}
        onChange={handleChange}
        className="w-full px-4 py-2 border rounded-xl shadow-sm bg-white focus:outline-none focus:ring-2 focus:ring-yellow-300"
      >
        <option value="created_at">Created At</option>
        <option value="name">Name</option>
      </select>
    </div>

    {/* Search */}
    <div>
      <label className="block mb-1 text-sm font-semibold text-gray-700 flex items-center gap-2">
        <FaSearch className="text-gray-500" />
        Search:
      </label>
      <input
        type="text"
        name="search"
        value={localFilters.search}
        onChange={handleChange}
        placeholder="Cari obat..."
        className="w-full px-4 py-2 border rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow-300"
      />
    </div>

    {/* Buttons */}
    <div className="space-y-2 pt-2">
      <button
        onClick={applyFilters}
        className="w-full bg-yellow-400 text-white font-semibold py-2 rounded-xl shadow hover:bg-yellow-500 transition"
      >
        Terapkan Filter
      </button>
      <button
        onClick={onClose}
        className="w-full bg-gray-200 text-gray-800 font-medium py-2 rounded-xl hover:bg-gray-300 transition flex items-center justify-center gap-2"
      >
        <FaWindowClose />
        Tutup
      </button>
    </div>
  </div>
</div>
  );
};

export default FilterModel;
